export default __webpack_public_path__ + "static/media/international_inbound.7b35b532.svg";